<template>
    <div class="doctor_list_page">
        <router-view v-wechat-title='$route.meta.title'></router-view>
        <!-- <van-dropdown-menu class="tab">
        <van-dropdown-item v-model="value1" :options="option1" />
        <van-dropdown-item v-model="deptCode" :options="option2" @change="change"  />
        </van-dropdown-menu> -->
        
        <div class="doctor_list">
            <div class="doctor_item flex2" v-for="item in dataList " @click="gotoDetail(item)" :key="item.DoctorId">
                <img :src="item.PicUrl" class="doctor_img">
                <div class="doctor_detail">
                    <div class="flex2" style="margin-bottom: 2px;">
                        <div class="name">{{item.Name}}</div>
                        <div class="position joint1">{{item.Professional}}</div>
                        <div class="department joint1">{{item.Department}}</div>
                    </div>
                    <!-- <div class="belong joint2">{{item.Hospital}}</div> -->
                    <div class="language joint2">语言：{{item.Language}}</div>
                    <div class="good_at joint2 line1">擅长：{{item.GoodAt}}</div>
                    <!-- <div class="flex2 inquiry_item_box">
                        <div class="pic_inquery">图文问诊</div>
                        <div class="pic_inquery">视频问诊</div>
                        <div class="joint3">语音问诊</div>
                    </div> -->
                </div>

            </div>

            <div class="no_doctor_list" v-if="dataList == ''">
                <img src="../images/no_doctor.png" alt="">
                <div>该科室暂无医生在线</div>
            </div>

        </div>

    </div>
</template>

<script>
import { DropdownMenu, DropdownItem, Toast } from 'vant';
import {SearchDoctor} from "@/utils/api.js"
export default {
    data(){
        return{
            deptCode:"",
            value1: 0,
            value2: '',
            dataList:[],
            option1: [
                { text: '莲藕互联网医院', value: 0 },
            ],
            option2: [
                { text: '全部科室', value: '' },
                { text: '内科', value: '103' },
                { text: '外科', value: '104' },
                { text: '儿科', value: '107' },
                { text: '预防保健科', value: '101' },
                { text: '全科医疗科', value: '102' },
                { text: '妇产科', value: '105' },
                { text: '妇女保健科', value: '106' },
                { text: '小儿外科', value: '108' },
                { text: '儿童保健科', value: '109' },
                { text: '眼科', value: '110' },
                { text: '耳鼻咽喉科', value: '111' },
                { text: '口腔科', value: '112' },
                { text: '皮肤科', value: '113' },
                { text: '医疗美容科', value: '114' },
                { text: '精神科', value: '115' },
                { text: '传染科', value: '116' },
                { text: '结核病科', value: '117' },
                { text: '地方病科', value: '118' },
                { text: '肿瘤科', value: '119' },
                { text: '中医科', value: '150' },
            ]
        }
    },
    methods:{
        getDocList(){
            SearchDoctor({
                doctorName:"",
                pageIndex:1,
                deptCode:this.deptCode,
                PageSize:1000

            }).then(res=>{
                console.log(res)
                if(res.code==1){
                    this.dataList = res.data.list
                }else{
                    Toast(res.msg)
                }
                
            })
        },
        change(e){
            console.log(e)
            this.deptCode = e 
            this.getDocList()
        },
        gotoDetail(item){
            console.log(JSON.stringify(item))
            this.$router.push({path:"/doctorDetails",query:{
                id:item.DoctorId,
                Name:item.Name
            }})
        }
    },
    mounted(){
        // document.title=this.$route.meta.title
        this.deptCode  = this.$route.query.deptCode||""
        this.getDocList()
    }
}
</script>

<style lang="scss" scoped>
.doctor_list_page{
    .tab{
        position: fixed;
        width: 100%;
        z-index: 1;
    }
    .doctor_list{
        padding-top: 30px;
        .doctor_item{
            padding: 17px 15px;
            align-items: flex-start;
            .doctor_img{
                width: 55px;
                height: 55px;
                border-radius: 50%;
            }
            .doctor_detail{
                margin-left: 15px;
                .name{
                    font-size:17px;
                    font-family:STXihei;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                }
                .position{
                    margin: 0 10px;
                    position: relative;
                }
                .position::after{
                    display: block;
                    content: "";
                    position: absolute;
                    width:1px;
                    height:11px;
                    background:rgba(102,102,102,1);
                    top: 0;
                    right: -5px;
                    top: 50%;
                    transform: translateY(-50%);

                }
                .joint1{
                    font-size:14px;
                    font-family:STXihei;
                    color:rgba(51,51,51,1);
                }
                .joint2{
                    font-size:13px;
                    font-family:STXihei;
                    font-weight:500;
                    color:rgba(153,153,153,1);
                    margin-bottom: 2px;
                }
                .belong{
                    margin-top: 8px;
                }
                .good_at{
                    max-width: 257px;
                }
                .inquiry_item_box>div{
                    width:60px;
                    height:20px;
                    border-radius:2px;
                    text-align: center;
                    line-height: 20px;
                    font-size: 11px;
                    font-family:STXihei;
                }
                .inquiry_item_box{
                    margin-top: 10px;
                    .pic_inquery{
                        color:rgba(255,255,255,1);
                        background:#FF9130;
                        margin-right: 5px;
                    }
                    .joint3{
                        color:#FF9130;
                        background:rgba(255,145,48,.15);
                    }

                }
            }    
        }
    }
    .no_doctor_list{
        text-align: center;
        img {
            width: 190px;
            height: 90px;
            margin: 90px 0 26px;
        }
        div {
            font-size:14px;
            font-family:PingFang SC;
            font-weight:400;
            color:rgba(153,153,153,1);
        }
    }
}
                // <div class="doctor_detail">
                //     <div class="flex2">
                //         <div class="name">林伟辉</div>
                //         <div class="position">医师</div>
                //         <div class="department">儿科</div>
                //     </div>
                //     <div class="belong">莲藕互联网医院</div>
                //     <div class="language">语言：普通话</div>
                //     <div class="good_at">擅长：</div>
                //     <div class="flex2 inquiry_item_box">
                //         <div class="">图文问诊</div>
                //         <div>语音问诊</div>
                //         <div>视频问诊</div>
                //     </div>
                // </div>
</style>
